import axios from "axios";
import { mapState } from "vuex";

export default {
	data: () => {
		return {
			res: null,
			loading: false,

			action: {
				//CATALOG
				getFilters: "quantity-products/catalog/get-filters",

				// CART
				updateCart: "quantity-cart/cart/cart-update",
				paymentsPay: "commerce/payments/pay",
				redeemCode: "quantity-cart/cart/redeem-code",
				removeCode: "quantity-cart/cart/remove-code",
				addToCart: "quantity-cart/cart/add-to-cart",
				isSubscribed: "quantity-subscriptions/subscriptions/is-subscribed",

				// FAVORITE
				favoriteFrontend: "quantity-favorite/favorite/frontend",
				favorite: "quantity-favorite/favorite/favorite",

				// ENTRIES
				getBlogFilters: "quantity-entries/blog/get-blog-filters",

				//RECOMMENDATIONS
				recommendation:
					"quantity-recommendations/recommendation/get-recommended-products",
				addProductRecommendation:
					"quantity-recommendations/recommendation/add-product-recommendation",

				// ACCOUNT
				saveAddress: "users/save-address",
				saveUser: "users/save-user",

				//REVIEWS
				postReview: "quantity-shop/review/post-review",

				//NOTIFICATIONS
				postStockNotification: "quantity-inventory/notification/sign-up",

				// NEWSLETTER
				newsletterSignup: "craftcms-klaviyo/api/subscribe",

				// SERVICEPOINTS
				getServicePoints: "quantity-subscriptions/frontend/get-service-points",
			},
			endpoint: {
				//CATALOG
				getCatalog: "api/qd-catalog/get-catalog/",
				getFilters: "api/qd-catalog/get-filters/",

				// ENTRIES
				getBlogs: "api/qd-entries/get-blogs/",
				getBlogFilters: "api/qd-entries/get-blog-filters/",

				//RECOMMENDATIONS
				recommendation: "api/qd-recommendations/get-product-recommendations/",

				// REVIEWS
				getReviews: "api/v1/shop/reviews/get/",
			},
		};
	},

	computed: {
		...mapState({
			csrf: (state) => state.app.csrfToken,
		}),
	},

	methods: {
		//Rename this to: postRequest
		request(formData, load = true, url = document.location.href) {
			if (!formData) {
				formData = new FormData();
			}

			formData.append("CRAFT_CSRF_TOKEN", this.csrf);

			this.loading = true;
			return axios
				.post(url, formData)
				.then((res) => {
					if (load) {
						this.loading = false;
					}
					this.res = res;
				})
				.catch((error) => {
					if (load) {
						this.loading = false;
					}
					this.res = error.response;
				});
		},
		getRequest(query, params = null, load = true, url = this.siteUrl) {
			this.loading = true;
			return axios
				.get(url + query, { params: params })
				.then((res) => {
					if (load) {
						this.loading = false;
					}
					this.res = res;
				})
				.catch((error) => {
					if (load) {
						this.loading = false;
					}
					this.res = error.response;
				});
		},
	},
};
